// Row 1.7 — optional global footer. Minimal by design (matrix: "Footer (optional global)", LOW
// severity, no spec detail beyond that) — a thin persistent bar, not page content, mounted via
// AppShellLayout's new `footer` slot (additive, same pattern as `bottomTabBar`).
// Row 17.1 — string-externalized (one of this batch's 2-3 proof surfaces; a partial, disclosed
// externalization pass, not the whole app).
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useChromeVisible } from "../state/useChromeVisible";

export function Footer(): ReactElement | null {
  const { t } = useTranslation();
  // Post-build review (MED, fixed): fullscreen/embed sub-apps hide the rest of the shell chrome
  // via this same check (SideNav.tsx, BottomTabBar.tsx) — the footer must honor it too, or a
  // chrome-free canvas would still show this bar underneath it.
  const chromeVisible = useChromeVisible();
  if (!chromeVisible) return null;
  return (
    <footer className="flex h-8 shrink-0 items-center justify-between border-t border-[var(--color-border-subtle)] bg-[var(--surface-sunken)] px-3 text-xs text-[var(--color-text-secondary)]">
      <span>{t("footer.productName")}</span>
      <span>{t("footer.copyright", { year: new Date().getFullYear() })}</span>
    </footer>
  );
}
